import { render, staticRenderFns } from "./Everyday_stretches.vue?vue&type=template&id=485e5668&"
import script from "./Everyday_stretches.vue?vue&type=script&lang=js&"
export * from "./Everyday_stretches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports